'use strict'

import wait from './wait'
import shuffle from './shuffle'
import GA from './GA'


/*
  Traveling Sales Person

  Customized to our needs
*/
export default class TSP {
  constructor (width, height, onstart, onstop, render) {
    this.width = width
    this.height = height
    this.nodes = []
    this.orders = []
    this.mutation_rate = 0.05
    this.is_running = false
    this._onstart = onstart
    this._onstop = onstop
    this.render = render
  }

  // add node of interest
  addNode(lat,lng,pen) {
    if (lat == null || lng == null) {
      return 
    }

    this.last_best_score = -1
    this.last_best_gen = 0

    this.nodes.push({
      x: lng,
      y: lat,
      pen: pen      
    })
    this.orders.push(this.nodes.length - 1)
  }

  makeRandomNodes (n = 32, life_count = 100) {
    this.is_running = false
    this.n = n
    this.life_count = life_count
    this.nodes = []
    this.orders = []

    let padding = 20

    for (let i = 0; i < n; i++) {
      this.nodes.push({
        x: Math.floor(Math.random() * (this.width - padding * 2)) + padding,
        y: Math.floor(Math.random() * (this.height - padding * 2)) + padding
      })
      this.orders.push(i)
    }

    shuffle(this.orders)
    this.orders.push(this.orders[0])

    this.ga = new GA({
      life_count: this.life_count,
      mutation_rate: this.mutation_rate,
      gene_length: this.n,
      rate: this.rate.bind(this),
      xFunc: this.xFunc.bind(this),
      mFunc: this.mFunc.bind(this)
    })
  }

  setGA(life_count = 100) {
    this.is_running = false
    this.n = this.nodes.length
    this.life_count = life_count

    this.ga = new GA({
      life_count: this.life_count,
      mutation_rate: this.mutation_rate,
      gene_length: this.n,
      rate: this.rate.bind(this),
      xFunc: this.xFunc.bind(this),
      mFunc: this.mFunc.bind(this)
    })
  }

  rate (gene) {
    return 1/this.getDistance(gene)
  }

  // genetic replication from two parents
  xFunc (lf1, lf2) {
    let p1 = Math.floor(Math.random() * (this.n - 2)) + 1
    let p2 = Math.floor(Math.random() * (this.n - p1)) + p1
    let piece = lf2.gene.slice(p1, p2)
    let new_gene = lf1.gene.slice(0, p1)
    piece.concat(lf2.gene).map(i => {
      if (!new_gene.includes(i)) {
        new_gene.push(i)
      }
    })

    return new_gene
  }

  // mutate the path
  mFunc (gene) {
    let p1 = 0
    let p2 = 0
    let n = gene.length
    while (p1 === p2) {
      p1 = Math.floor(Math.random() * n)
      p2 = Math.floor(Math.random() * n)
    }
    if (p1 > p2) {
      [p1, p2] = [p2, p1]
    }

    let funcs = [
      (g, p1, p2) => {
        let t = g[p1]
        g[p1] = g[p2]
        g[p2] = t
      }, (g, p1, p2) => {
        let t = g.slice(p1, p2).reverse()
        g.splice(p1, p2 - p1, ...t)
      }, (g, p1, p2) => {
        let t = g.splice(p1, p2 - p1)
        g.splice(Math.floor(Math.random() * g.length), 0, ...t)
      }
    ]

    let r = Math.floor(Math.random() * funcs.length)
    funcs[r](gene, p1, p2)

    return gene
  }

  // get distance between two nodes
  static distance(node1, node2) {
    var point1 = turf.point([node1.x,node1.y])
    var point2 = turf.point([node2.x,node2.y])
    return turf.distance(point1, point2)
  }

  // calculate distance for the given path
  getDistance (order = null) {
    var d = 0
    let {nodes} = this
    
    // concat first value to end to create a loop
    var _orders = order.concat(order[0])
    for(var i = 0; i < _orders.length - 1; i++) {
      var node1 = nodes[_orders[i]]
      var node2 = nodes[_orders[i+1]]
      d += TSP.distance(node1, node2)
    }
    return d
  }

  // function that continuously runs until stopped
  // applies genetic algorithm to find the best path
  async run () {
    let last_best_score = -1
    let last_best_gen = 0

    let update = true

    // find and update the best path found so far
    while (this.is_running) {
      this.orders = this.ga.next()

      let {best, generation} = this.ga

      if (last_best_score !== best.score) {
        last_best_score = best.score
        last_best_gen = generation
        update = true
      } else if (generation - last_best_gen >= 5000) {
        this.stop()
        break
      }

      if (this.ga.generation % 100 === 0 && update == true) {
        this.render()
        update = false
      }
      await wait(1) // wait so as to give the ui a chance to update
    }
  }

  // start the path finding algorithm
  start () {
    if (this.nodes.length > 1 && this.is_running == false) {
      this.is_running = true
      this.run()
      if (typeof this._onstart === 'function') {
        this._onstart()
      }
    }
  }

  // stop the path finding algorithm
  stop () {
    this.is_running = false

    if (typeof this._onstop === 'function') {
      this._onstop()
    }
  }
}
